<template>
  <div id="device_list" class="modal">
    <div class="modal-content animate">
      <div class="col-md-12 card">
        <div class="card-header">
          <div class="category">{{'Danh sách thiết bị khu vực ' + areaIndex}} </div>
          <p-button type="success" @click="sendData">Gửi lệnh điều khiển</p-button>
          <span onclick="document.getElementById('device_list').style.display='none';" class="close" title="Close Modal">&times;</span>
        </div>
        <div class="card-body row">
          <div class="col-sm-6">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page">
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <fg-input class="input-sm"
                        placeholder="Search"
                        v-model="searchQuery"
                        addon-right-icon="nc-icon nc-zoom-split">
              </fg-input>
            </div>
          </div>
          <div class="col-sm-12 mt-2">
            <el-table class="table-striped"
                      :data="queriedData"
                      border
                      style="width: 100%">
              <el-table-column
                key="Id Node"
                min-width="200"
                prop="id"
                label="Id Node">
              </el-table-column>
              <el-table-column
                key="Tên"
                min-width="200"
                prop="name"
                label="Tên">
              </el-table-column>
              <el-table-column
                key="Cổng điều khiển"
                min-width="200"
                prop="port"
                label="Cổng điều khiển">
              </el-table-column>
              <el-table-column
                :min-width="120"
                fixed="right"
                class-name="td-actions"
                label="Trạng thái">
                <template slot-scope="props">
                  <p-switch v-model="props.row.active" on-text="ON" off-text="OFF"></p-switch>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
          </div>
          <div class="col-sm-6">
            <p-pagination class="pull-right"
                          v-model="pagination.currentPage"
                          :per-page="pagination.perPage"
                          :total="pagination.total">
            </p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import { Card } from 'src/components/UIComponents';
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import {Table, TableColumn, Select, Option, InputNumber} from 'element-ui'
  import PPagination from 'src/components/UIComponents/Pagination.vue'
  import {Button} from 'src/components/UIComponents'
  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Select)
  Vue.use(Option)

  export default {
    components: {
      Card,
      PSwitch,
      PPagination,
      [Button.name]: Button
    },
    props:{
      areaIndex: Number,
      tableData: {
            id: Number,
            name: String,
            port: Number,
            active: Boolean
        },
      isRegionControl:false
    },
    computed: {
      pagedData () {
        return this.tableData.slice(this.from, this.to)
      },
      /***
       * Searches through table data and returns a paginated array.
       * Note that this should not be used for table with a lot of data as it might be slow!
       * Do the search and the pagination on the server and display the data retrieved from server instead.
       * @returns {computed.pagedData}
       */
      queriedData () {
        if (!this.searchQuery) {
          this.pagination.total = this.tableData.length
          return this.pagedData
        }
        let result = this.tableData
          .filter((row) => {
            let isIncluded = false
            for (let key of this.propsToSearch) {
              let rowValue = row[key].toString()
              if (rowValue.includes && rowValue.includes(this.searchQuery)) {
                isIncluded = true
              }
            }
            return isIncluded
          })
        this.pagination.total = result.length
        return result.slice(this.from, this.to)
      },
      to () {
        let highBound = this.from + this.pagination.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.pagination.perPage * (this.pagination.currentPage - 1)
      },
      total () {
        this.pagination.total = this.tableData.length
        return this.tableData.length
      }
    },
    data () {
      return {
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0
        },
        searchQuery: '',
        propsToSearch: ['name', 'parent', 'active'],
      }
    },
    methods: {
      sendData () {
        alert(`Hành động gửi dữ liệu điều khiển`)
      }
    },
    async mounted() {
      
    }
  }
</script>
<style>
.modal{
    display: none;
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    min-width: 900px;
    height: 100%;
    min-height: 600px;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
    padding-top: 60px;
}
  #worldMap {
    height: 500px;
  }
.modal-content {
    background-color: #fefefe;
    margin: 3% 2% 0% auto; /* 0% from the top, 15% from the bottom and centered */
    border: 1px solid #888;
    width: 70%; /* Could be more or less, depending on screen size */
    height:auto;
    border-radius:5px;
}

.close {
    color: #000;
    font-size: 35px;
    font-weight: bold;
}

.close:hover,
.close:focus {
    color: red;
    cursor: pointer;
}

/* Add Zoom Animation */
.animate {
    -webkit-animation: animatezoom 0.6s;
    animation: animatezoom 0.6s
}

@-webkit-keyframes animatezoom {
    from {-webkit-transform: scale(0)} 
    to {-webkit-transform: scale(1)}
}
  
@keyframes animatezoom {
    from {transform: scale(0)} 
    to {transform: scale(1)}
}
</style>
-